export const FETCH_ANEES_VOUCHERS_DATA = "FETCH_ANEES_VOUCHERS_DATA";
export const FETCH_ANEES_VOUCHERS_SUCCESS = "FETCH_ANEES_VOUCHERS_SUCCESS";
export const FETCH_ANEES_VOUCHERS_FAILURE = "FETCH_ANEES_VOUCHERS_FAILURE";